import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { supabase } from '../lib/supabase';
import { indiceMesAtual, ordenarAvisos, situacaoDoAviso } from '../lib/avisosUc';
import { buscarAvisosDasUcs, type AvisoComCiencia } from '../services/avisosUc';

// Avisos de uma UC para a tela da UC (faixa no topo + aba "Avisos"). Falha na leitura
// não trava a tela: fica a lista vazia e o erro, para a aba avisar.
export function useAvisosUc(ucId: number | string | null | undefined) {
    const [avisos, setAvisos] = useState<AvisoComCiencia[]>([]);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState<string | null>(null);
    const pedido = useRef(0);

    const recarregar = useCallback(async () => {
        const meu = ++pedido.current;
        if (!ucId) {
            setAvisos([]);
            setErro(null);
            return;
        }
        setCarregando(true);
        try {
            const lista = await buscarAvisosDasUcs(supabase, [ucId]);
            if (meu !== pedido.current) return;
            setAvisos(lista);
            setErro(null);
        } catch (e: any) {
            if (meu !== pedido.current) return;
            setAvisos([]);
            setErro(e?.message || 'Não foi possível ler os avisos da UC.');
        } finally {
            if (meu === pedido.current) setCarregando(false);
        }
    }, [ucId]);

    useEffect(() => { recarregar(); }, [recarregar]);

    const mesAtual = indiceMesAtual();
    const ordenados = useMemo(() => ordenarAvisos(avisos, mesAtual), [avisos, mesAtual]);
    const ativos = useMemo(() => ordenados.filter(a => situacaoDoAviso(a, mesAtual) === 'ativo'), [ordenados, mesAtual]);

    return { avisos: ordenados, ativos, mesAtual, carregando, erro, recarregar };
}
